module.exports = __webpack_public_path__ + "static/img/wenzi.c444a47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/WZBankMin/wenzi.png
// module id = zNes
// module chunks = 69